<template>
  <v-app class=" debugOutline1  "
>
    <v-app-bar
      app
      color="primary"
      dark
      height=40px
      class="pt-0 debugOutline2  "
      >

      <v-layout wrap>
        <v-flex xs8>
                <v-icon dark v-if="1==1">mdi-android </v-icon>
                <span class="mr-0">Chelsea Cyber Crawler</span> 
        </v-flex>
        <v-flex xs3>
            {{$store.state.loading}}
            <span class="ml-2 tSmaller">TOP SECRET</span>
        </v-flex>
        <v-flex xs1>
            {{$store.state.loading}}
            <span class="ml-2 tSmallest tLightGray">{{$vuetify.breakpoint.name}}</span>
        </v-flex>
                                  <!--
                                          <v-spacer></v-spacer>
                                          <v-flex xs1>
                                              <ParamsSelectorToggle />
                                          </v-flex>
                                  -->
      </v-layout>

    </v-app-bar>

    <ParamsSelector v-model="showParamsSelector" />

                                  <!--
                                        <v-spacer></v-spacer>
                                  -->
    <v-content>
      <v-layout>
        <v-spacer></v-spacer>
        <v-flex xs1>
            <ParamsSelectorToggle />
        </v-flex>
      </v-layout>


      <!--
      readyToProceed = {{readyToProceed}} <br>
      $store.state.loading = {{ $store.state.loading }} <br>
      $store.getters.selectedDate2 = {{ $store.getters.selectedDate2 }} <br>
      $store.state.sniffing.sniffed = {{ $store.state.sniffing.sniffed }} <br>
      -->

      <div v-if="readyToProceed">

                                  <!-- 
                                  <div v-if="$store.state.settings.showTechnical && $store.state.loading.length==0">

                                      <h3>OpeningsTest in App.vue</h3>
                                  $store.state.sniffing.teeSheetDate = 
                                    {{$store.state.sniffing.teeSheetDate}}
                                  <br>
                                  $store.state.sniffing = 
                                    {{$store.state.sniffing}}
                                  <br>

                                    v-if="$store.state.loading.length==0"

                                  -->

        <OpeningsTest
          v-if="readyToProceed"
          />

        <v-layout>
          <v-flex xs12>
            <!-- <hr>Home.vue -->
            <Home
              v-if="readyToProceed"
              />
            <!-- <hr> -->
          </v-flex>
        </v-layout>

      </div>

    </v-content>
                                  <!--
                                  <OpenByHour2
                                    :teeSheetDate= "$store.state.sniffing.teeSheetDate"
                                  />>
                                        <Home/>
                                  -->

  </v-app>
</template>

<script>
import { mapState } from 'vuex';


import Home from './components/Home'
import ParamsSelectorToggle from './components/ParamsSelectorToggle'
import ParamsSelector from './components/ParamsSelector'

import OpeningsTest from './components/OpeningsTest'

export default {
  name: 'App',

  components: {
    Home,
    ParamsSelectorToggle, // added 2019-12-01
    ParamsSelector, // added 2020
    OpeningsTest
  },

  data: () => ({
    showParamsSelector: false,
    readyToProceed: false
  }),

  computed: mapState(['loading']),

    /*
    computed: {
    loadingStatus () {
      return this.$store.getters.selectedDate2
    },
    */

    pageSize () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return 'xs'
        case 'sm': return 'sm'
        case 'md': return 'md'
        case 'lg': return 'lg'
        case 'xl': return 'xl'
      }
    },




// https://vuetifyjs.com/en/customization/breakpoints
    mounted () {
      console.log("$vuetify.breakpoint",this.$vuetify.breakpoint)
    },



  watch: {

    loading(newValue, oldValue) {
      console.log(`Updating loading from ${oldValue} to ${newValue}`)
      if (newValue=="") this.readyToProceed = true

    /*
    loading: function  () {
      const d = "d"+this.$store.getters.selectedDate2
            //console.log("teeSheets",this.$store.state.teeSheets)
            //console.log("teeSheets sniffing",this.$store.state.sniffing.teeSheetDates2)
            //console.log("d",d)
            //console.log("state",this.$store.state)
      const opens = this.$store.state.teeSheets[d]
      if (opens!=undefined) this.readyToProceed = true
    },
    */

    }
  },

};
</script>
